import { McAction } from '../../IMcAction';
import { Lab } from '../../../contracts/lab/lab.model';

export const SET_CURRENT_LAB = 'lab/SET_CURRENT_LAB';
export const CLEAR_CURRENT_LAB = 'lab/CLEAR_CURRENT_LAB';
export const GET_LABS_SUCCESS = 'lab/GET_LABS_SUCCESS';
export const GET_LAB_INSTRUMENTS_SUCCESS = 'lab/GET_LAB_INSTRUMENTS_SUCCESS';
export const GET_STUDY_TEST_TEA_CONFIGS = 'lab/GET_STUDY_TEST_TEA_CONFIGS';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/lab/lab.action.const.ts